<div class="chat-container">
    <!-- Compact Header -->
    <div class="chat-header">
        <div class="header-left">
            <div class="ai-avatar">
                <i class="fa fa-robot"></i>
            </div>
            <div class="header-text">
                <span class="ai-title">Protean Assistant</span>
                <span class="status-dot"></span>
            </div>
        </div>
        <button class="clear-btn" (click)="clearChat()" title="Clear Chat">
            <i class="fa fa-trash-o"></i>
        </button>
    </div>

    <!-- Messages Area -->
    <div class="messages-container" #chatContainer>
        @if(messages.length === 0){
        <div class="empty-state">
            <div class="empty-icon-wrapper">
                <div class="empty-icon-bg"></div>
                <i class="fa fa-comments empty-icon"></i>
            </div>
            <h3 class="empty-title">Protean Assistant</h3>
            <p class="empty-subtitle">Ask me anything about system disconnections, devices, or configurations.</p>
            
            <div class="quick-prompts-grid">
                <div class="quick-prompt-card" (click)="useQuickSuggestion('how many disconnections today')">
                    <div class="quick-prompt-icon text-warning"><i class="fa fa-bolt"></i></div>
                    <div class="quick-prompt-content">
                        <span class="quick-prompt-title">Disconnections today</span>
                        <span class="quick-prompt-desc">Check stats for today</span>
                    </div>
                    <i class="fa fa-chevron-right quick-prompt-arrow"></i>
                </div>
                <div class="quick-prompt-card" (click)="useQuickSuggestion('total disconnections lifetime')">
                    <div class="quick-prompt-icon text-success"><i class="fa fa-bar-chart"></i></div>
                    <div class="quick-prompt-content">
                        <span class="quick-prompt-title">Lifetime disconnections</span>
                        <span class="quick-prompt-desc">View total history</span>
                    </div>
                    <i class="fa fa-chevron-right quick-prompt-arrow"></i>
                </div>
                <div class="quick-prompt-card" (click)="useQuickSuggestion('how many disconnections yesterday')">
                    <div class="quick-prompt-icon text-info"><i class="fa fa-history"></i></div>
                    <div class="quick-prompt-content">
                        <span class="quick-prompt-title">Yesterday's count</span>
                        <span class="quick-prompt-desc">See yesterday's data</span>
                    </div>
                    <i class="fa fa-chevron-right quick-prompt-arrow"></i>
                </div>
                <div class="quick-prompt-card" (click)="useQuickSuggestion('how many disconnections excluding automatic timeout')">
                    <div class="quick-prompt-icon text-danger"><i class="fa fa-filter"></i></div>
                    <div class="quick-prompt-content">
                        <span class="quick-prompt-title">Exclude timeouts</span>
                        <span class="quick-prompt-desc">Ignore auto timeouts</span>
                    </div>
                    <i class="fa fa-chevron-right quick-prompt-arrow"></i>
                </div>
            </div>
        </div>
        }

        @for(message of messages; track message.id){
        <div class="message-group">
            <!-- User Question -->
            <div class="message user-message">
                <div class="message-bubble user-bubble">
                    {{ message.question }}
                </div>
            </div>

            <!-- AI Answer -->
            <div class="message ai-message">
                <div class="message-avatar">
                    <i class="fa fa-robot"></i>
                </div>
                <div class="message-bubble ai-bubble">
                    @if(message.isLoading){
                    <div class="typing-indicator">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    }
                    @if(!message.isLoading){
                    <div class="message-text" [innerHTML]="message.formattedAnswer"></div>

                    @if(message.tableData && message.tableHeaders) {
                    <div class="dynamic-table-container">
                        <div class="table-toolbar" style="justify-content: space-between;">
                            <div class="search-box">
                                <i class="fa fa-search"></i>
                                <input type="text" [(ngModel)]="message.searchQuery" placeholder="Search table...">
                            </div>
                            <div class="table-actions" style="display: flex; gap: 8px;">
                                <button class="btn btn-sm btn-outline-primary" style="display: flex; align-items: center; gap: 6px;" (click)="openGraphModal(message)" title="View Graph">
                                    <i class="fa fa-bar-chart"></i> Graph
                                </button>
                                <button class="btn btn-sm btn-outline-success" style="display: flex; align-items: center; gap: 6px;" (click)="exportToExcel(message)" title="Export to Excel">
                                    <i class="fa fa-file-excel-o"></i> Export
                                </button>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="chat-dynamic-table">
                                <thead>
                                    <tr>
                                        @for(header of message.tableHeaders; track header) {
                                        <th (click)="sort(message, header)">
                                            {{header}}
                                            @if(message.sortKey === header) {
                                            <i class="fa"
                                                [ngClass]="message.sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                                            } @else {
                                            <i class="fa fa-sort" style="opacity: 0.3"></i>
                                            }
                                        </th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(row of (message.tableData | search:message.searchQuery |
                                    sort:message.sortKey:message.sortDirection); track row) {
                                    <tr>
                                        @for(header of message.tableHeaders; track header) {
                                        <td>{{row[header]}}</td>
                                        }
                                    </tr>
                                    }
                                    @if((message.tableData | search:message.searchQuery)?.length === 0) {
                                    <tr>
                                        <td [attr.colspan]="message.tableHeaders.length" class="text-center text-muted">
                                            No matching records found.
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <!-- Compact Input Area -->
    <div class="input-container">
        <div class="input-wrapper">
            <textarea #messageInput [(ngModel)]="newMessage" (input)="onInput()" (keydown)="handleKeyDown($event)"
                rows="1" class="message-input" placeholder="Type your query..."></textarea>

            <button class="send-btn" (click)="sendMessage()" [disabled]="!newMessage.trim()">
                <i class="fa fa-paper-plane"></i>
            </button>

            <div class="suggestions" *ngIf="showSuggestions && suggestions.length">
                <div class="suggestion" *ngFor="let suggestion of suggestions; let i = index"
                    [class.active]="i === selectedIndex" (click)="selectSuggestion(suggestion)">
                    <i class="fa fa-search suggestion-icon"></i>
                    <span class="suggestion-text">{{ suggestion.completion }}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- suggestions -->
    

    <!-- Confirm Delete Modal -->
    <ng-template #confirmDeleteTemplate let-modal>
        <div class="modal-body text-center">
            <p>Are you sure you want to clear all messages?</p>
            <button type="button" class="btn btn-danger" (click)="confirmClear()">Yes</button>&nbsp;
            <button type="button" class="btn btn-secondary" (click)="cancelClear()">No</button>
        </div>
    </ng-template>

    <!-- Graph Modal -->
    <ng-template #graphModalTemplate let-modal>
        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e2e8f0; padding: 16px; background: #f8fafc; border-top-left-radius: 16px; border-top-right-radius: 16px;">
            <h4 class="modal-title" style="margin: 0; font-size: 18px; color: #1e293b; font-weight: 600;"><i class="fa fa-pie-chart text-primary"></i> Disconnection Details</h4>
            <button type="button" aria-label="Close" (click)="closeGraphModal()" style="background: transparent; border: none; font-size: 20px; cursor: pointer; color: #64748b; padding: 0;"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-body" style="padding: 16px; background: #ffffff;">
            <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 6px; background: #f8fafc; padding: 12px; border-radius: 12px; border: 1px solid #e2e8f0;">
                <label style="font-size: 14px; font-weight: 600; color: #475569;">Group By:</label>
                <select [(ngModel)]="selectedGraphColumn" (change)="updateGraph()" style="padding: 8px 12px; border-radius: 8px; border: 1px solid #cbd5e1; outline: none; background: white; font-size: 14px; min-width: 150px;">
                    @for(header of currentGraphMessage?.tableHeaders; track header) {
                        <option [value]="header">{{header}}</option>
                    }
                </select>
                <label style="font-size: 14px; font-weight: 600; color: #475569; margin-left: 12px;">Chart Type:</label>
                <select [(ngModel)]="selectedGraphType" (change)="updateGraph()" style="padding: 8px 12px; border-radius: 8px; border: 1px solid #cbd5e1; outline: none; background: white; font-size: 14px; min-width: 150px;">
                    <option value="bar">Bar Chart</option>
                    <option value="pie">Pie Chart</option>
                    <option value="doughnut">Doughnut Chart</option>
                    <option value="line">Line Chart</option>
                </select>
            </div>
            <div style="position: relative; height: 260px; width: 100%;">
                <canvas id="dynamicChartCanvas"></canvas>
            </div>
        </div>
    </ng-template>